import { render } from "./ProjectAnalysisAuto.vue?vue&type=template&id=e4b84f7e"
import script from "./ProjectAnalysisAuto.vue?vue&type=script&lang=js"
export * from "./ProjectAnalysisAuto.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__